var a = (n, g, i) => new Promise((s, r) => {
  var u = (t) => {
    try {
      e(i.next(t));
    } catch (o) {
      r(o);
    }
  }, y = (t) => {
    try {
      e(i.throw(t));
    } catch (o) {
      r(o);
    }
  }, e = (t) => t.done ? s(t.value) : Promise.resolve(t.value).then(u, y);
  e((i = i.apply(n, g)).next());
});
import { selfAxios as c } from "@oppein/op-utils";
function p() {
  return a(this, null, function* () {
    const { data: n } = yield c.get(
      "/ucenterapi/internal/region/getRegionCountryListByPid"
    );
    return n;
  });
}
export {
  p as getRegionCountryListByPid
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/ucenterapi/internal/region/getRegionCountryListByPid/get.js
// module id = 1835
// module chunks = 67